var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldhockey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "fieldhockey.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapeWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {},
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.749533,27.135466 24.818196,27.005997 18.290819,15.460638 h -1.801354 l 7.177652,12.695415 c 0.133103,0.235302 0.377967,0.385586 0.647947,0.39758 l 3.365289,0.14852 c 0.01199,7.05e-4 0.02342,7.05e-4 0.03503,7.05e-4 0.417265,0 0.764116,-0.328436 0.78299,-0.7493 0.01901,-0.432506 -0.316124,-0.798689 -0.748841,-0.818092",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.529922,7.8297013 10.939812,5.9645651 14.543543,5.639304 c 0.14358,-0.013053 0.277389,-0.054681 0.396875,-0.1181806 0.148801,-0.1485195 0.294463,-0.2956278 0.436668,-0.4423834 0.0889,-0.1710972 0.132292,-0.3683 0.1137,-0.574675 C 15.438826,3.9290372 14.931175,3.505351 14.355688,3.5565038 L 8.7392194,4.0637983 c -0.38929,0.035278 -0.72637,0.2846917 -0.873936,0.6462889 -0.147603,0.3619501 -0.08118,0.7761112 0.172402,1.0735029 L 11.02155,9.2831459 c 0.49209,-0.4871862 0.999631,-0.9726084 1.508372,-1.4534446",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.254367,10.026801 c -0.312102,0.313973 -0.69095,0.602192 -1.128042,0.849137 -0.283175,0.163336 -0.571606,0.327377 -0.860848,0.492125 l 0.241264,2.9718 -0.674828,3.401836 c -0.112289,0.566208 0.255658,1.116542 0.822148,1.228725 0.06862,0.01376 0.137125,0.02011 0.204647,0.02011 0.488632,0 0.925336,-0.344664 1.02429,-0.84208 l 0.703369,-3.544359 c 0.01859,-0.0949 0.02424,-0.191911 0.01626,-0.288219 l -0.348263,-4.289073",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.086448,15.460638 H 8.6080564 L 6.585899,21.586624 1.5563423,25.220941 c -0.62397541,0.45085 -0.76439751,1.322211 -0.3136413,1.946275 0.2727156,0.37712 0.6986665,0.577498 1.1312321,0.577498 0.2829102,0 0.5684415,-0.08573 0.8151108,-0.264231 l 5.3955525,-3.898547 c 0.237879,-0.171803 0.415502,-0.414162 0.507401,-0.692856 l 2.2178076,-6.720064 2.972858,5.671961 -0.144427,6.219825 c -0.01778,0.769762 0.59175,1.407937 1.36137,1.425928 0.01118,0 0.02205,3.53e-4 0.03309,3.53e-4 0.754733,0 1.375269,-0.602897 1.392908,-1.361369 l 0.152541,-6.580365 c 0.0055,-0.236361 -0.04904,-0.4699 -0.158891,-0.67945 l -2.832806,-5.405261",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.613938,7.2737235 c -1.347717,0.9274528 -3.103457,0.7154334 -3.921866,-0.4734278 -0.818586,-1.189214 -0.389326,-2.9051252 0.958144,-3.832578 1.347858,-0.9274529 3.103739,-0.7154334 3.922043,0.4737806 0.818409,1.1892139 0.389431,2.9047724 -0.958321,3.8322252",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.212153,25.035733 c 0,0.822325 -0.666574,1.489075 -1.489252,1.489075 -0.822713,0 -1.489534,-0.66675 -1.489534,-1.489075 0,-0.822678 0.666821,-1.489428 1.489534,-1.489428 0.822678,0 1.489252,0.66675 1.489252,1.489428",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22.801824,8.8968542 c -1.23003,0 -2.313164,-0.5482167 -2.970918,-1.5038918 -0.594043,-0.8632473 -0.730215,-1.9177001 -0.469618,-2.9072418 -0.78479,-0.5312834 -1.85607,-0.1248834 -2.82388,0.8904111 -2.094336,2.2493113 -5.116937,4.6947673 -6.9552256,7.0252173 -0.121285,0.151694 -0.164395,0.333375 -0.144428,0.51823 h 7.0162916 c 1.626623,-0.968022 3.433234,-1.960386 5.158388,-2.9541609 0.550545,-0.3104444 0.968904,-0.6861528 1.233769,-1.0703278 -0.01475,3.528e-4 -0.02963,0.00176 -0.04438,0.00176",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldhockey);
export default __webpack_public_path__ + "static/media/fieldhockey.f24e9c786cd18745bc936b848d521187.svg";
export { ForwardRef as ReactComponent };